<template>
  <div class="chart-content">
    <div class="chart" ref="myChart">
    </div>
  </div>
</template>

<script>
import elementResizeDetectorMaker from "element-resize-detector";
import {
  GetStockInOutBySixMonths
} from '@/api'
import BaseReportMixin from '@/mixin/baseReport-mixin.js'
export default ({
  mixins: [BaseReportMixin],
  data () {
    return {
      myChart: null,
      option: {},
      data: [],
      nameData: [],
      lineValue: [],
      bar2Value: [],
      line2Value: [],
      setInterval: null
    };
  },
  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    },
    isShowCloseBtn: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  //监听beforinfo值的变化
  watch: {
    data: {
      handler (newVal, oldVal) {
        this.initOption()
        this.option.series[0].data = newVal
        if (!this.myChart) {
          this.myChart = this.$echarts.init(this.$refs['myChart'])
        }
        this.myChart.setOption(this.option);
      },
      deep: true
    },
    lineValue: {
      handler (newVal, oldVal) {
        this.initOption()
        this.option.series[1].data = newVal
        if (!this.myChart) {
          this.myChart = this.$echarts.init(this.$refs['myChart'])
        }
        this.myChart.setOption(this.option);
      },
      deep: true
    },
  },
  methods: {
    // 获取列表
    getData () {
      GetStockInOutBySixMonths({})
        .then(res => {
          this.nameData = res.returnData.map(e => e.name);
          this.data = res.returnData.map(e => e.value);
          this.lineValue = res.returnData.map(e => e.lineValue);
          this.bar2Value = res.returnData.map(e => e.bar2Value);
          this.line2Value = res.returnData.map(e => e.line2Value);
        })
    },
    initOption () {
      let that = this;
      this.option = {
        title: {
          text: this.name,
          textStyle: {
            color: "#FFF" // 标题颜色
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#283b56'
            }
          }
        },
        legend: {
          top: '93%', // 图列位置
          textStyle: {
            color: "#FFF" // 图列颜色
          },
        },
        toolbox: this.getToolBox(this),
        dataZoom: {
          show: false,
          start: 0,
          end: 100
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true,
            data: this.nameData,
            axisLabel: {//底部文字设置
              color: "#a9a6b8"
            },
            axisLine: {
              lineStyle: {
                color: '#a9a6b8'
              } // x轴坐标轴颜色
            },
          }
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            name: '金额(万元)',
            min: 0,
            boundaryGap: [0.2, 0.2],
            // nameTextStyle: {
            //   color: "green",
            //   fontSize: 12,
            // },
            // axisLine: {
            //   show: false,//坐标轴线
            // },
            nameLocation: 'start', //坐标轴名称显示位置。 底部
            nameGap: 22, //坐标轴名称与轴线之间的距离。
            nameTextStyle: {
              color: "#fff",//"orange", // 橙色（数量）
              fontSize: 12,
            },
            axisLine: {
              show: true,//坐标轴线
              lineStyle: {
                color: '#a9a6b8'
              }
            },
            splitLine: {
              show: false // 去掉坐标横线
            },
            axisTick: {
              show: true //刻度 -
            },
          }, {
            type: 'value',
            scale: true,
            name: '数量',
            min: 0,
            boundaryGap: [0.2, 0.2],
            // nameTextStyle: {
            //   color: "#65ABE7", // 蓝色
            //   fontSize: 12,
            // },
            // axisLine: {
            //   show: false,//坐标轴线
            // },
            nameLocation: 'start', //坐标轴名称显示位置。 底部
            nameGap: 22, //坐标轴名称与轴线之间的距离。
            nameTextStyle: {
              color: "#fff",//"orange", // 橙色（数量）
              fontSize: 12,
            },
            axisLine: {
              show: true,//坐标轴线
              lineStyle: {
                color: '#a9a6b8'
              }
            },
            splitLine: {
              show: false // 去掉坐标横线
            },
            axisTick: {
              show: true //刻度 -
            },
          },
        ],
        color: ['#06B5D7', '#d5dd2d', '#007ffd', 'orange'],
        series: [
          {
            name: '入库数量',
            type: 'bar',
            data: this.data,
            yAxisIndex: 1,

          },
          {
            name: '入库金额',
            type: 'line',
            data: this.lineValue,
          },
          {
            name: '出库数量',
            yAxisIndex: 1,
            type: 'bar',
            data: this.bar2Value
          },
          {
            name: '出库金额',
            // yAxisIndex: 1,
            type: 'line',
            data: this.line2Value,
          },
        ],
        grid: {
          left: '18%',
          right: '15%',
          show: false
        }
      }
      // X、Y 双轴对齐
      // 获取数量最大值
      // var numberMax = Math.max.apply(null, this.data)
      // var outNumberMax = Math.max.apply(null, this.bar2Value)
      // if (outNumberMax > numberMax) {
      //   numberMax = outNumberMax
      // }
      // this.option.yAxis[0].max = Math.ceil(numberMax / 5) * 5;
      // this.option.yAxis[0].interval = Math.ceil(numberMax / 5);

      // // 获取金额最大值
      // var amountMax = Math.max.apply(null, this.lineValue)
      // var outAmountMax = Math.max.apply(null, this.line2Value)
      // if (outAmountMax > amountMax) {
      //   amountMax = outAmountMax
      // }
      // this.option.yAxis[1].max = Math.ceil(amountMax / 5) * 5;
      // this.option.yAxis[1].interval = Math.ceil(amountMax / 5);

    },


    init () {
      this.initOption()
      // this.option.width = this.width
      // this.option.height = this.height
      this.myChart = this.$echarts.init(this.$refs['myChart'])
      this.myChart.setOption(this.option);

      // // 随窗口的大小变化自适应
      // window.addEventListener("resize", function () {
      //   myChart.resize();
      // });
      //  随外层div的大小变化自适应
      const _this = this
      let erd = elementResizeDetectorMaker();
      erd.listenTo(this.$refs.myChart, (e) => {
        _this.$nextTick(() => {
          _this.myChart.resize();
          // console.log(e.parentNode, "e.parentNode");
          var parentNodeId = e.parentNode.parentElement.id
          // console.log(parentNodeId, "e.parentNodeId");
          var domId = document.getElementById(parentNodeId);
          if (domId != null) {
            _this.$emit('SizeChange', domId.clientWidth, domId.clientHeight, parentNodeId)
          }
        })
      })
    },

  },//自定义指令


  mounted () {
    this.init()
    let that = this
    this.setInterval = setInterval(function () {
      that.getData();
    }, 5 * 60 * 1000)
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.getData();
  },
  beforeDestroy () {
    clearInterval(this.setInterval)
  },
})
</script>
<style scoped lang="scss">
.chart-content {
  width: 400px;
  height: 300px;
  display: flex;
  .chart {
    width: 100%;
    height: 100%;
    position: absolute; // 拖动时报表随div缩放
  }
}
// .tag-list {
//   display: list-item;
//   line-height: 40px;
//   width: 190px;
//   padding: 4% 0;
//   .tag-text {
//     color: #fff;
//     margin-left: 10px;
//     font-size: 14px;
//   }
// }
</style>
